var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"ps-missing"},[_c('h1',{staticClass:"ps-display mb-4"},[_vm._v("Nothing here")]),_c('p',{staticClass:"ps-lede mb-4"},[_vm._v("This page doesn’t exist. Everything about PolySigma is on the home page.")]),_c('b-button',{attrs:{"to":{ name: 'home' },"variant":"primary","size":"lg"}},[_vm._v("Go to the home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }